import moment from 'moment';

const states = {
  kpi_details: {
    selected_date_range: {
      startDate: moment(new Date(), "DD-MM-YYYY").subtract(1, 'days'),
      endDate: moment(new Date(), "DD-MM-YYYY").subtract(1, 'days'),
    },
    selected_filters: {},
    filters: [],
    stats_list: [],
    agent_live_kpis: [],
    loaders: {}
  },
}

export default states



// WEBPACK FOOTER //
// ./src/data/redux/kpi_details/states.js